import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import swal from "sweetalert2";
import * as fromRootStore from "../../../reducers";
import { SaleDC } from "../../../services/salesDc.service";
declare var google;

@Component({
  selector: "dcList",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./dcList.html",
})
export class DcComponent implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;

  groupbyList = ["RETAIL", "WHOLESALE", "ESTIMATE"];
  filter = {
    dc_no: "",
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "po_id",
    orderDir: "desc",
  };
  finyearList = [];
  agentList = [];
  seasonfinList = [];
  partyAgentList = [];
  partyList = [];
  dcList = [];

  @ViewChild("snoTemplate") snoTemplate: TemplateRef<any>;
  @ViewChild("invoiceTemplate") invoiceTemplate: TemplateRef<any>;
  @ViewChild("detailsTemplate") detailsTemplate: TemplateRef<any>;
  @ViewChild("editDeleteTemplate") editDeleteTemplate: TemplateRef<any>;
  @ViewChild("filterPanel") filterPanel;
  @ViewChild("partyDataTable") partyDataTable;
  @ViewChild("finAuto") finAuto;
  @ViewChild("partyAuto") partyAuto;

  finCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  invCtrl: FormControl = new FormControl();
  columns = [];
  toggleCol = [];
  menu: any;
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  sampleList: any = [];
  totpcs: any;

  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private dcservice: SaleDC
  ) {}

  ngOnInit(): void {
    this.getColumns();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        headerClass: "text-center",
        sortable: false,
        cellTemplate: this.snoTemplate,
        toggle: true,
        cellClass: "text-center",
      },
      {
        name: "Dc No",
        prop: "dc_no",
        cellClass: "text-center",
        headerClass: "text-center",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
      },
      {
        name: "Dc Date",
        prop: "dc_dt_formatted",
        headerClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
      },
      {
        name: "Design No",
        prop: "design_no",
        headerClass: "text-center",
        cellClass: "text-center",
        minWidth: 160,
        maxWidth: 160,
        width: 160,
      },
      {
        name: "F36",
        prop: "f36",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F38",
        prop: "f38",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F40",
        prop: "f40",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F42",
        prop: "f42",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F44",
        prop: "f44",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "F46",
        prop: "f46",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H36",
        prop: "h36",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H38",
        prop: "h38",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H40",
        prop: "h40",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H42",
        prop: "h42",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H44",
        prop: "h44",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "H46",
        prop: "h46",
        headerClass: "text-center",
        cellClass: "text-right",
        minWidth: 70,
        maxWidth: 70,
        width: 70,
      },
      {
        name: "Action",
        prop: "sno",
        minWidth: 80,
        maxWidth: 80,
        cellClass: "text-center",
        width: 80,
        sortable: false,
        cellTemplate: this.editDeleteTemplate,
      },
    ];
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#dc_no").focus();
    }, 100);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.DCList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  clearFilter(): void {
    this.filter.dc_no = "";
    this.applyFilter();
  }

  applyFilter(): void {
    //this.filterExpand = false;
    this.filterPanel.close();
    this.DCList();
  }

  addEditEntry(mode: string, row: any): void {
    let listUpdateEvent = new EventEmitter();
    listUpdateEvent.subscribe(() => {
      this.DCList();
    });
    row.tabevent = listUpdateEvent;
    let tabObj = {};
    if (mode == "Add") {
      tabObj = {
        action: "NewTab",
        params: {
          //  tabParent: 'Transaction',
          tabName: "DC ENTRY",
          title: "DC ENTRY",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "DC ENTRY",
        },
      };
    } else {
      tabObj = {
        action: "NewTab",
        params: {
          tabName: "EDIT DC",
          title: "EDIT DC",
          tabParent: "MASTER",
          mode: mode,
          data: row,
          name: "EDIT DC",
        },
      };
    }
    this.tabUpdateEvent.emit(tabObj);
  }
  DCList(): void {
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      dc_no: this.filter.dc_no,
    };
    let that = this;
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    that.isLoadMask = that.dcservice.dcList(params).then(function (res: any) {
      that.loadingIndicator = false;
      that.page.count = res.total;
      that.dcList = res.data;
      for (let i = 0; i < that.dcList.length; i++) {
        that.dcList[i].dc_dt_formatted = that.datePipe.transform(
          that.dcList[i].dc_dt,
          "dd-MM-yyyy"
        );
      }
    });
  }

  deleteEntry(row: any): void {
    let that = this;
    let params = {
      dc_id: row.dc_id,
    };
    swal({
      title: "Are you sure to delete this DC?",
      text: "You will not be able to recover this details",
      type: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, delete it!",
      cancelButtonText: "No, keep it",
    }).then(
      function () {
        that.isLoadMask = that.dcservice
          .deleteDc(row)
          .then(function (res: any) {
            that.loadingIndicator = false;
            that.DCList();
            let errtype = "success",
              errmsg = res.message;
            if (!res.success) {
              errtype = "error";
            }

            that.toasterService.pop({
              bodyOutputType: 1,
              type: errtype,
              title: errtype.toUpperCase(),
              body: errmsg,
            });
          });
      },
      function (dismiss) {}
    );
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/Dc/dcList.ts